export const buttonStyled = { width: { xs: "100%", lg: "fit-content" }, justifyContent: "center" };

export const listCityStyled = (props) => {
  const { top = 72, left = 0, right = 0 } = props || {};
  return {
    top,
    left,
    right,
    position: "absolute",
    border: "1px solid",
    borderColor: "componentColors.20",
    bgcolor: "#fff",
    maxHeight: 280,
    zIndex: 300,
    // Correctif pour safari :
    WebkitTransform: "translate3d(0,0,0)",
    transform: "translate3d(0,0,0)",
    m: 0,
    p: 0,
    overflowX: "hidden",
    overflowY: "auto",
    listStyle: "none",
    "& > li": {
      display: "flex",
      justifyContent: "space-between",
      p: 2,
      cursor: "pointer",
    },
    "& > li:hover": {
      bgcolor: "componentColors.20",
    },
  };
};

export const suggestionStyled = (isHighlighted) => ({
  bgcolor: isHighlighted ? "componentColors.20" : "transparent",
  textDecoration: isHighlighted ? "underline" : "none",
});
